import React, { useState, useEffect } from "react";
import firebase from "firebase/app";
import { runAnalytics } from "../../../utils";

function RerunCheckup(props) {
  const [running, setRunning] = useState("rerun");
  const [token, setToken] = useState("");

  useEffect(() => {
    firebase
      .auth()
      .currentUser.getIdToken()
      .then(id_token => {
        setToken(id_token);
      });
  }, [token]);

  const clickHandler = event => {
    event.stopPropagation();
    const userEmail = firebase.auth().currentUser.email;

    if (runAnalytics({ userEmail, window }))
      window.analytics.track("Rerun website check", {
        url: `${props.url}`
      });

    if (running === "rerun") {
      setRunning("running");

      const headers = new Headers();
      headers.append("Authorization", `Bearer ${token}`);
      headers.append("Content-Type", "application/json");

      fetch(
        "https://us-central1-broadlume-fit.cloudfunctions.net/rerunCheckup",
        {
          method: "POST",
          headers,
          body: JSON.stringify({ url: props.url })
        }
      )
        .then(response => {
          setRunning(response.ok ? "success" : "error");
          setTimeout(() => setRunning("rerun"), 3000);
        })
        .catch(error => {
          setRunning("error");
          console.log(error);
          setTimeout(() => setRunning("rerun"), 3000);
        });
    }
  };

  const rerunImg = {
    height: "30px",
    cursor: "pointer",
    marginLeft: "15px"
  };

  return (
    <>
      {running === "rerun" && (
        <img
          src="images/rerun.png"
          alt="rerun"
          style={rerunImg}
          className="rerun-checkup"
          onClick={e => clickHandler(e, props.url)}
        />
      )}
      {running === "running" && (
        <img
          src="images/rerun.png"
          alt="running"
          style={rerunImg}
          className="column-line__rerun__spin rerun-checkup"
        ></img>
      )}
      {running === "success" && (
        <img
          src="images/check_mark.png"
          alt="success"
          className="rerun-checkup"
          style={rerunImg}
        />
      )}
      {running === "error" && (
        <img
          src="images/error.png"
          alt="error"
          className="rerun-checkup"
          style={rerunImg}
        />
      )}
    </>
  );
}

export default RerunCheckup;
